import React from 'react';
import { vendorRspReportSPD } from '../../actions/invoiceDateActions';
import ResponseReportView from './ResponseReportView';

// SPD version: no "late" column or late totals.
const VendorResponseReportSPD = () => (
    <ResponseReportView
        stateKey="vendorspReportSPD"
        resetType="VENDOR_REPORT_SPD_RESET"
        fetchReport={vendorRspReportSPD}
        showLate={false}
        filePrefix="Response_Report_SPD"
    />
);

export default VendorResponseReportSPD;
